/** @jsxImportSource @emotion/react */
import React, { useEffect, useState } from "react";
import type { LatLngTuple } from "leaflet";


import * as UI from "@goodgym/components";
import * as T from "@goodgym/graphql/types";

export type MapProps = UI.BoxProps & { session: T.SessionCardFragment };

const Map: React.FC<MapProps> = ({ session, ...props }) => {
  const lat = session.address?.lat;
  const lng = session.address?.lng;

  const [MapComponents, setMapComponents] = useState<any>(null);
  const [redIcon, setRedIcon] = useState<any>(null);

  useEffect(() => {
    Promise.all([
      import("react-leaflet"),
      import("leaflet"),
    ]).then(([leafletReact, leaflet]) => {
      setMapComponents({
        MapContainer: leafletReact.MapContainer,
        TileLayer: leafletReact.TileLayer,
        Marker: leafletReact.Marker,
        Popup: leafletReact.Popup,
      });

      setRedIcon(
        new leaflet.Icon({
          iconUrl:
            "https://raw.githubusercontent.com/pointhi/leaflet-color-markers/master/img/marker-icon-red.png",
          shadowUrl:
            "https://unpkg.com/leaflet@1.9.4/dist/images/marker-shadow.png",
          iconSize: [25, 41],
          iconAnchor: [12, 41],
          popupAnchor: [1, -34],
          shadowSize: [41, 41],
        })
      );
    });
  }, []);

  useEffect(() => {
      // @ts-ignore: dynamic import of CSS is fine, TS doesn't need to understand it
    import('leaflet/dist/leaflet.css');
  }, []);

  if (
    typeof lat !== "number" ||
    typeof lng !== "number" ||
    typeof window === "undefined" ||
    !MapComponents ||
    !redIcon
  ) return null;

  const { MapContainer, TileLayer, Marker, Popup } = MapComponents;
  const position: LatLngTuple = [lat, lng];

  return (
    <UI.Box
      {...props}
      sx={{
        position: "relative",
        width: "100%",
        height: "300px",
        ...props.sx,
      }}
    >
      <MapContainer
        center={position}
        zoom={15}
        scrollWheelZoom={false}
        style={{ height: "100%", width: "100%" }}
      >
        <TileLayer
          attribution='&copy; OpenStreetMap contributors'
          url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
        />
        <Marker position={position} icon={redIcon}>
          <Popup>{session.title || "Session location"}</Popup>
        </Marker>
      </MapContainer>
    </UI.Box>
  );
};

export default Map;
